import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import home from "../assets/list-settings-fill 1.svg";
import bookings from "../assets/ic-business-center-24px 1.svg";
import card from "../assets/bookmark-2-fill 1.svg";
import card_1 from "../assets/card.svg";
import discount from "../assets/mdi_brightness-percent.svg";
import settings from "../assets/user-3-fill 2.svg";
import clock from "../assets/clock.png";
import { connect } from "react-redux";
import Task from "../common/Task";
import policyIcon from "../assets/ShieldCheck.svg";

const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
});

export default connect(mapStateToProps)(
  class SettingsLinks extends Component {
    state = {
      user_is_team_member:
        this.props.userProfile?.account_type === "business_team_member",
    };

    render() {
      return (
        <div className="setting-links card">
          {!this.state.user_is_team_member ? (
            <>
              <NavLink
                to={{ pathname: "/business/settings" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                <img src={bookings} alt="" />
                Business information
              </NavLink>

              <NavLink
                to={{ pathname: "/business/opening_hours" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                {/* <img src={clock} alt="Opening Hours" /> */}
                <svg
                  style={{ marginRight: "20px" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM14 14C13.9075 14.0927 13.7976 14.1663 13.6766 14.2164C13.5557 14.2666 13.426 14.2924 13.295 14.2924C13.164 14.2924 13.0343 14.2666 12.9134 14.2164C12.7924 14.1663 12.6825 14.0927 12.59 14L9.3 10.71C9.20551 10.6174 9.13034 10.5069 9.07885 10.3851C9.02735 10.2632 9.00055 10.1323 9 10V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V9.59L14 12.59C14.39 12.98 14.39 13.61 14 14Z"
                    fill="#2A2B79"
                  />
                </svg>
                Opening hours
              </NavLink>

              <NavLink
                to={{ pathname: "/discount/settings" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                <img src={discount} alt="" />
                Discounts
              </NavLink>
              <NavLink
                to={{ pathname: "/bookings/settings" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                <img src={card} alt="" />
                Booking settings
              </NavLink>
              <NavLink
                to={{ pathname: "/payout/settings" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                <img src={card_1} alt="" />
                Payout settings
              </NavLink>
              <NavLink
                to={{ pathname: "/policy/settings" }}
                className="link flex center"
                onClick={this.props.onNavigate}
              >
                <img src={policyIcon} alt="" />
                Booking Policy
              </NavLink>
            </>
          ) : (
            ""
          )}

          <NavLink
            to={{ pathname: "/profile/integration" }}
            className="link flex center mobile_only"
          >
            <img src={card} alt="" />
            Integrations
          </NavLink>
          <NavLink
            to={{ pathname: "/profile/settings" }}
            className="link flex center mobile_only"
          >
            <img src={settings} alt="" />
            Profile settings
          </NavLink>
        </div>
      );
    }
  }
);
